module.exports = __webpack_public_path__ + "static/media/graviola-digital-logo.03cc0376.svg";